import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Autoplay, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getAllPublicEvents } from '../../app/store/slices/event/event';
import EventMainCard from '../Cards/EventMainCard';
import '../../styles/components/HappeningEvents.css';

export default function HappeningEvents() {

    const dispatch = useDispatch();

    const [events, setEvents] = useState([]);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await dispatch(getAllPublicEvents()).unwrap();

                // console.log('Fetched events:', response);

                setEvents(response?.data);
            } catch (error) {
                console.error('Failed to fetch events:', error);
            }
        };
        fetchEvents();
    }, [dispatch]);

    // console.log('Events state:', events);

    return (
        <div className="happening-events-container">
            <Swiper
                spaceBetween={0}
                slidesPerView={3.6}
                centeredSlides={true}
                loop={false}
                speed={1000}
                autoplay={{
                    delay: 4500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                }}
                navigation={true}
                mousewheel={true}
                pagination={{ clickable: true }}
                modules={[Navigation, Pagination, Autoplay, Mousewheel]}
                className="happening-events"
            >
                {events.map((event, index) => (
                    <SwiperSlide key={index} className="swiper-slide">
                        <div>
                            <EventMainCard
                                key={index}
                                slug={event?.slug}
                                name={event?.excerpt}
                                location={event?.address}
                                startingTime={event?.start_time}
                                startingDate={event?.start_date}
                                price={event?.min_ticket_price}
                                organizerAvatar={event?.user_avatar}
                                format={event?.formats}
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="explore-all-btn">
                <Link to="/events">
                    <Button variant='main'>
                        Explore all
                    </Button>
                </Link>
            </div>
        </div>
    );
}